<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="close" v-on:click="close(false)"></div>
        <div class="payungB"></div><div class="leafL"></div>
        <h4>Download Brosur</h4>
        <div class="liCnt">
          <a :href="calUri" class="li" target="_blank" download>
            <div class="icon"></div> Booklet - Nutrilite Mixed Collagen Drink
          </a>
          <a :href="calUri2" class="li" target="_blank" download>
            <div class="icon"></div> Flyer - Nutrilite Mixed Collagen Drink
          </a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },
  computed: {
    calUri() {
      return 'https://storage.googleapis.com/deepdivedjkt/clg/docs/'
        + 'Booklet%20-%20Nutrilite%20Mixed%20Collagen%20Drink.pdf';
    },
    calUri2() {
      return 'https://storage.googleapis.com/deepdivedjkt/clg/docs/'
        + 'Flyer%20-%20Nutrilite%20Mixed%20Collagen%20Drink.pdf';
    },
  },
  methods: {
    open(d, n) {
      this.show = true;
    },
    close(b, d) {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
.leafL{
  width: 280px; height: 280px;
  position: absolute;
  left: -100px; bottom: -96px;
  background-image: url(../assets/leaf-l.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
}

  .userModal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;
    @media (max-width: 680px) {
      padding: 20px 10px;
    }
    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background: #ffe7ea;
      width: 260px;
      margin: auto;
      border-radius: 5px;
      padding: 40px 100px;
      overflow: hidden;
      transition: all .3s ease;
      .payungB{
        width: 160px; height: 160px;
        position: absolute;
        right: -100px; bottom: 40px;
        opacity: .6;
        background-image: url(../assets/umbrela-pink.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        z-index: 7;
        // @media (max-width: 960px) {
        //   display: block;
        //   width: 240px; height: 240px;
        //   top: 50%; left: -140px; margin-top: -40px;
        // }
        // @media (max-width: 680px) {
        //   display: block;
        //   width: 140px; height: 140px;
        //   top: 50%; left: -80px; margin-top: -40px;
        // }
      }
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        opacity: .4;
        cursor: pointer;
        transition: all .2s linear;
      }
      .close:hover{
        background-color: #e5e5e5;
        opacity: .7;
      }
      h4{
        margin: 0 0 20px;
        font-size: 16px;
        color: #ca7e8b;
      }
      .liCnt{
        margin: 0 -100px;
        position: relative;
        z-index: 9;
        .li{
          list-style: none;
          padding: 12px 60px;
          margin: 0 40px 10px;
          font-size: 17px;
          cursor: pointer;
          color: #444;
          transition: all .3s ease;
          position: relative;
          display: block;
          text-decoration: none;
          border-radius: 10px;
          background-color: #fff3f4;
          @media (max-width: 680px) {
            padding: 12px 16px;
            padding-left: 60px;
            margin: 0 20px 10px;
          }
          .icon{
            position: absolute;
            left: 20px; top: 0; bottom: 0; width: 24px;
            background-position: center;
            background-size: 24px auto;
            background-repeat: no-repeat;
            background-image: url(../assets/download-o.png);
            opacity: .6;
            @media (max-width: 680px) {
              // left: 34px;
            }
            &.google{
              background-image: url(../assets/google.png);
            }
            &.apple{
              background-image: url(../assets/apple.png);
            }
            &.outlook{
              background-image: url(../assets/outlook.png);
            }
            &.office{
              background-image: url(../assets/office.png);
            }
            &.other{
              background-image: url(../assets/calendar.png);
            }
          }
          &:hover{
            background-color: #efd5d8;
          }
        }
      }
    }
  }
</style>
